import React from 'react'

const UserVerification = () => {
  return (
    <div className='flex justify-center'>
        <div className='mt-[9rem] p-8'>
          <h3 className='text-[3rem] text-center'>Attention!</h3>
          <p className='text-[1.4rem] text-justify'>We have sent you an email to validate that these changes are being made by you.</p>
          <p className='text-[1.4rem] text-justify'>Please check your email and click on the link we have sent you.</p>
        </div>
    </div>
  )
}

export default UserVerification